import styled, {keyframes} from "styled-components";

type ContainerType = {
    background: string;
    border: string;
};

type TextType = {
    color: string;
};

type IconCircleType = {
    background: string;
};

type PillType = {
    color: string;
    background: string;
};

type SkeletonBoneType = {
    background: string;
    highlight: string;
    width?: string;
    height?: string;
    borderRadius?: string;
};

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const Card = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.border};
  background: ${(props) => props.background};
  min-width: 0;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const IconCircle = styled.div<IconCircleType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: ${(props) => props.background};
`;

export const CardTitle = styled.span<TextType>`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.color};
  line-height: 1.3;
`;

export const ValuesBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ValuesDivider = styled.div<{border: string}>`
  width: 100%;
  height: 1px;
  background: ${(props) => props.border};
`;

export const ValueGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ValueRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ValueLabel = styled.span<TextType>`
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => props.color};
  line-height: 1.2;
`;

export const CurrentValue = styled.span<TextType>`
  font-size: 22px;
  font-weight: 700;
  color: ${(props) => props.color};
  line-height: 1.2;
  word-break: break-word;
`;

export const PreviousValue = styled.span<TextType>`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.color};
  line-height: 1.2;
  word-break: break-word;
`;

export const SecondaryValue = styled.span<TextType>`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color};
  line-height: 1.2;
`;

export const VariationPill = styled.div<PillType>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: auto;
  padding: 8px 12px;
  border-radius: 20px;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

export const VariationPercent = styled.span`
  font-size: 15px;
  font-weight: bold;
`;

export const SkeletonBone = styled.div<SkeletonBoneType>`
  width: ${(props) => props.width ?? '100%'};
  height: ${(props) => props.height ?? '14px'};
  border-radius: ${(props) => props.borderRadius ?? '6px'};
  background: linear-gradient(
    90deg,
    ${(props) => props.background} 25%,
    ${(props) => props.highlight} 50%,
    ${(props) => props.background} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;
